var _path, _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_542_1985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49967 4.16671H0.833008V17.5C0.833008 18.4167 1.58301 19.1667 2.49967 19.1667H15.833V17.5H2.49967V4.16671ZM17.4997 0.833374H5.83301C4.91634 0.833374 4.16634 1.58337 4.16634 2.50004V14.1667C4.16634 15.0834 4.91634 15.8334 5.83301 15.8334H17.4997C18.4163 15.8334 19.1663 15.0834 19.1663 14.1667V2.50004C19.1663 1.58337 18.4163 0.833374 17.4997 0.833374ZM17.4997 14.1667H5.83301V2.50004H17.4997V14.1667Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_542_1985)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -10.833,
    y: -10.8334,
    width: 41.6667,
    height: 41.6667,
    fill: "#7F7F86"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_542_1985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -11,
    y: -11,
    width: 42,
    height: 42
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -10.833,
    y: -10.8334,
    width: 41.6667,
    height: 41.6667,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_542_1985)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic-copy.d1647f35ccde9b7ee11f8516d096ce76.svg";
export { ForwardRef as ReactComponent };